import { render } from "./DashboardAfterSalesOverview.vue?vue&type=template&id=7808c72c&scoped=true"
import script from "./DashboardAfterSalesOverview.vue?vue&type=script&lang=js"
export * from "./DashboardAfterSalesOverview.vue?vue&type=script&lang=js"

import "./DashboardAfterSalesOverview.vue?vue&type=style&index=0&id=7808c72c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7808c72c"]])

export default __exports__